/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import { SafetyCertificateOutlined } from '@ant-design/icons';

import { Button, SectionCard } from '../../ui';
import DeductPlanModal from '../../detail/components/deductPlanModal';
import DepositRecords from '../../detail/components/depositRecords';
import ExpenditureDetail from '../../detail/components/expenditureDetail';
import { cardPad } from './constants';
import styles from '../../detail/index.less';

/**
 * MoneyCard —— 金额卡
 * 金额是资金页最需要一眼读到的信息，所以：货币符号小、数字大且等宽、
 * 可提现用主色、在途用预警色，保证金额外挂「记录」入口。
 */
const MoneyCard = ({ label, value, tone, accent, action }) => {
  const raw = String(value ?? '').replace(/[¥￥,\s]/g, '');
  const num = Number(raw);
  const isNum = raw !== '' && !Number.isNaN(num);
  const cls =
    tone === 'warning'
      ? styles.moneyWarning
      : tone === 'primary'
      ? styles.moneyPrimary
      : '';

  return (
    <div
      className={`${styles.moneyCard} ${
        accent ? styles.moneyAccent : ''
      } ${cls}`}
    >
      <div className={styles.moneyLabel}>
        {label}
        {action && <span className={styles.moneyAction}>{action}</span>}
      </div>
      <div className={styles.moneyValue}>
        {isNum ? (
          <>
            <span className={styles.moneySign}>¥</span>
            <span className={styles.moneyNum}>
              {num.toLocaleString('zh-CN', { minimumFractionDigits: 2 })}
            </span>
          </>
        ) : (
          <span className={styles.moneyRaw}>{value || '--'}</span>
        )}
      </div>
    </div>
  );
};

/** 资金与结算（资金概览 / 保证金记录 / 提现详情） */
export const FundPane = (props) => {
  const { tenantId, tenantInfo = {} } = props;
  const [deductVisible, setDeductVisible] = useState(false);

  return (
    <div>
      {/* 图3 反馈：四个金额必须在这里**好好展示**，且不再出现在基础信息里。
          merchantInfo 里的对应字段已移除，先用后付记录弹窗一并抽成
          DeductPlanModal 跟着入口搬过来。 */}
      <SectionCard
        title="资金概览"
        extra={
          <Button
            type="default"
            size="small"
            icon={<SafetyCertificateOutlined />}
            onClick={() => setDeductVisible(true)}
          >
            先用后付记录
          </Button>
        }
      >
        <div className={styles.moneyRow}>
          <MoneyCard
            label="保证金余额"
            value={tenantInfo.balanceStr}
            accent
            action={
              <a onClick={() => setDeductVisible(true)}>
                <SafetyCertificateOutlined /> 记录
              </a>
            }
          />
          <MoneyCard
            label="在途资金"
            value={tenantInfo.remunerationNotSettlement}
            tone="warning"
          />
          <MoneyCard
            label="可提现资金"
            value={tenantInfo.remunerationSettlement}
            tone="primary"
          />
          <MoneyCard
            label="累计提现"
            value={tenantInfo.remunerationWithdrawal}
          />
        </div>
      </SectionCard>

      <DeductPlanModal
        tenantId={tenantId}
        visible={deductVisible}
        setVisible={setDeductVisible}
      />

      <SectionCard title="保证金记录" bodyStyle={cardPad}>
        <DepositRecords tenantId={tenantId} />
      </SectionCard>

      <SectionCard title="提现详情" bodyStyle={cardPad}>
        <ExpenditureDetail tenantId={tenantId} />
      </SectionCard>
    </div>
  );
};

export default FundPane;
